import React from 'react';
import { motion } from 'framer-motion';
import { painPoints, planningLoop } from '../data/painPoints';
export function PainPoints() {
  return <section className="py-24 px-4 bg-zinc-100" data-id="element-152" data-mp="2lmiwupexkjae">
      <div className="max-w-4xl mx-auto" data-id="element-153" data-mp="26yxyf8t0388t">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-12" data-id="element-154" data-mp="26xwhwot7ttjp">
          <h2 className="text-3xl md:text-4xl font-black uppercase mb-6 text-zinc-950" data-id="element-155" data-mp="21zlb6my7vz5p">
            Does this sound familiar?
          </h2>
          <div className="text-lg text-zinc-700 leading-relaxed bg-white p-6 md:p-8 rounded-2xl border border-zinc-200 shadow-sm text-left space-y-4" data-id="element-156" data-mp="1o1ekprvll1g2">
            <p className="font-semibold text-zinc-950" data-id="element-157" data-mp="3id3549kllw7u">Tomorrow you have another MMA session.</p>
            <p data-id="element-158" data-mp="3nd7jnu1y4gvf">
              And instead of switching off for the day, you&apos;re still searching for drills,
              deciding which skill to teach, trying to connect striking with clinch or takedowns,
              and wondering whether the progression you created will actually work with the
              athletes who walk into the gym.
            </p>
            <p data-id="element-159" data-mp="27v37wtuml3ze">
              <span className="text-zinc-950 font-semibold" data-id="element-160" data-mp="23rdgzxqhaab7">Not because you don&apos;t know MMA.</span>{' '}
              Because knowing MMA and having a complete coaching system are two different things.
            </p>
            <p data-id="element-161" data-mp="1b39etm748fd9">Without structure, every session starts from an empty page.</p>
            <ul className="flex flex-wrap gap-x-4 gap-y-1 font-display font-bold text-violet-900" data-id="element-162" data-mp="1p2hai542l5cp">
              {planningLoop.map(step => <li key={step} data-id="element-163" data-mp="1k2mnwdrbv1xg">{step}</li>)}
            </ul>
            <p className="font-semibold text-zinc-950" data-id="element-164" data-mp="30guxl7r01gro">And next week, you do it all again.</p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-165" data-mp="2vi1ixbzz7jpx">
          <h3 className="text-xl font-extrabold uppercase text-zinc-950 mb-8 text-center" data-id="element-166" data-mp="1y6cjob2q034q">
            The real cost of building every MMA session from scratch
          </h3>
          <ul className="overflow-hidden rounded-xl border border-zinc-200 bg-white shadow-sm" data-id="element-167" data-mp="273mrtnk8rc5f">
            {painPoints.map((point, index) => <motion.li key={point} initial={{
            opacity: 0,
            x: -12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="px-5 py-4 text-zinc-700 text-sm leading-relaxed border-t first:border-t-0 border-zinc-200" data-id="element-168" data-mp="1eg8v9qkggilu" data-mpi={index}>
                <span className="mr-2 text-violet-600" aria-hidden="true" data-id="element-169" data-mp="vozk7cv1dls5">●</span>
                {point}
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-zinc-300" data-id="element-170" data-mp="o3vxorhi2z9k">
            <p className="text-xl mt-4 text-zinc-600" data-id="element-171" data-mp="j7yhqma5fuxb">Your coaching knowledge is already there.</p>
            <p className="text-2xl font-display font-black uppercase text-zinc-950 mt-2" data-id="element-172" data-mp="e695x4f3rd86">
              What you need is a <span className="text-violet-600" data-id="element-173" data-mp="a8judvpa40h1">system</span> that helps you use it
              faster.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}